import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const VOICES = [
  {
    id: "siti",
    name: "Bu Siti",
    role: "Ibu Rumah Tangga · Warga Dusun 1",
    initials: "BS",
    quote: "Sejak Pak Mulyono jadi Kades, bantuan kesehatan untuk warga kecil lebih gampang diurus. Malam-malam ada warga sakit aja, beliau langsung datang jemput pakai mobil desa.",
  },
  {
    id: "rendi",
    name: "Rendi",
    role: "Pemuda Dusun 2 · Wota JKT48",
    initials: "RD",
    quote: "Dulu kita bingung mau bikin acara ngumpul komunitas fans JKT48 di mana. Pak Kades malah fasilitasi halaman balai desa plus sound system-nya! Kades yang paling paham anak muda.",
  },
  {
    id: "tejo",
    name: "Tejo",
    role: "Ketua RT 03 · Komunitas Mancing",
    initials: "TJ",
    quote: "Baru kali ini ada Kades yang turun langsung ngecek spot mancing warga dan dukung kegiatan kita. Pak Mul emang merakyat, asyik diajak ngobrol di pos ronda.",
  },
];

export const Testimonials = () => (
  <section id="suara" data-testid="testimonials-section" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <SectionHeading
        bab="Bab 05"
        label="Suara Cianjay"
        title="Apa Kata Mereka tentang Cianjay Hari Ini?"
        testid="testimonials"
      />
      <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
        {VOICES.map((v, i) => (
          <motion.figure
            key={v.id}
            data-testid={`testimonial-card-${v.id}`}
            initial={{ opacity: 0, y: 44 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -6 }}
            className={`relative flex flex-col rounded-3xl border border-line p-7 sm:p-8 shadow-[0_10px_35px_rgba(30,58,43,0.07)] transition-shadow hover:shadow-[0_26px_55px_rgba(30,58,43,0.14)] ${
              i === 1 ? "bg-forest text-bg md:-translate-y-4" : "bg-surface"
            }`}
          >
            <Quote size={30} className={i === 1 ? "text-gold" : "text-terra"} fill="currentColor" strokeWidth={0} />
            <blockquote className={`mt-5 flex-1 text-sm sm:text-base leading-relaxed ${i === 1 ? "text-bg/90" : "text-ink/85"}`}>
              "{v.quote}"
            </blockquote>
            <figcaption className="mt-7 flex items-center gap-3.5">
              <span className={`grid place-items-center w-11 h-11 rounded-full font-serif font-bold text-sm ${
                i === 1 ? "bg-gold text-forest" : "bg-forest text-bg"
              }`}>
                {v.initials}
              </span>
              <span>
                <span className="block font-semibold text-sm">{v.name}</span>
                <span className={`block text-xs mt-0.5 ${i === 1 ? "text-bg/60" : "text-soft"}`}>{v.role}</span>
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
